module.exports = __webpack_public_path__ + "static/colgadas-014-f1baf950f3f85ee448b2423d284a508c.jpg";